import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Paper, { PaperProps } from "@mui/material/Paper";
import React, { useEffect, useRef } from "react";
import Draggable from "react-draggable";
import ApplicationHistory from "../applications/summary/ApplicationHistory";
import { DialogContent, CircularProgress } from "@mui/material";
import { Print } from "@mui/icons-material";
import ApplicationUnderwritingData from "./summary/ApplicationUnderwritingData";
import ApplicationBaseDataAsidePrint from "./summary/ApplicationBaseDataAsidePrint";
function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-application-print"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function ApplicationPrint({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const appId = props.appId;
  const record = props.record;

  const handlePrintAppHistory = () => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
    
      body * {
        visibility: hidden;
      }
        * {
        
        }
     
      body{
        width: 100% !important;
      }
        @page {
        margin: 0cm !important;
        }
      [class*="ApplicationPrintBody-${appId}"],
      [class*="ApplicationPrintBody-${appId}"] * {
        visibility: visible;
         overflow: visible !important;
        max-height: none !important;
        height: auto !important;
      }
      [class*="ApplicationPrintBody-${appId}"]{
        position: absolute;
        left: 0;
        top: 0;        
        width:100% !important;
        border:'2px solid pink';
      }
        
      [class*="ApplicationPrintBody-${appId}"], 
      .MuiCard-root,
      .MuiGrid-container
      {
        border: none !important;
        box-shadow: none !important;
      }
        .MuiAccordion-root{
            border-left: none !important;
            border-right: none !important;
        }
        .draggable-dialog-application-print{
            display: block !important;
        }
        .application-print-loading-icon{
            display: none !important;
        }
        .application-print-icon{
            display: none !important;
        }
        #appshow_31762, #sectionThree .MuiButton-root{
            display: none !important;
        } 
    }
  `;
    document.head.appendChild(style);

    window.print();

    setTimeout(() => {
      document.head.removeChild(style);
      setOpen(false);
      setLoading(false);
    }, 100);
  };
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handlePrintAppHistory();
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [open]);
  return (
    <>
      {loading ? (
        <CircularProgress
          size={16}
          color="inherit"
          sx={{
            ml: "auto",
            cursor: "pointer",
            float: "right",
            marginTop: "-45px",
          }}
          className="application-print-loading-icon"
        />
      ) : (
        <Print
          sx={{
            ml: "auto",
            cursor: "pointer",
            float: "right",
            marginTop: "-45px",
            color: "#1976d2",
            "&:hover": { color: "#0b4f94ff" },
          }}
          onClick={() => {
            setLoading(true);
            setOpen(true);
          }}
          className="application-print-icon"
        />
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth={true}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-application-print"
        maxWidth={false}
        className="draggable-dialog-application-print"
        sx={{ display: "none" }}
      >
        <DialogContent
          className={"ApplicationPrintBody-" + appId}
          sx={{
            width: "100%",
            padding: "0px",
          }}
        >
          <ApplicationBaseDataAsidePrint
            appId={appId}
            record={record}
            appStatus={record?.sStatus}
          />
          <ApplicationHistory appId={appId} record={record} />
          <ApplicationUnderwritingData
            appId={appId}
            record={record}
            appStatus={record?.sStatus}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
